import { DocumentSubCategoryFacade } from './../../../../../epims-references/src/lib/states/+document-sub-category/document-sub-category.facade';
import { CurrencyFacade } from './../../../../../epims-references/src/lib/states/+currency/currency.facade';
import { DocumentCategoryFacade } from './../../../../../epims-references/src/lib/states/+document-category/document-category.facade';
import { OilFieldFacade } from './../../../../../epims-references/src/lib/states/+oil-field/oil-field.facade';
import { OilBlockFacade } from './../../../../../epims-references/src/lib/states/+oil-block/oil-block.facade';
import { CommunityFacade } from './../../../../../epims-references/src/lib/states/+community/community.facade';
import { ClusterCommunityFacade } from './../../../../../epims-references/src/lib/states/+cluster-community/cluster-community.facade';
import { ClusterFacade } from './../../../../../epims-references/src/lib/states/+cluster/cluster.facade';
import { ProjectCategoryFacade } from './../../../../../epims-references/src/lib/states/+project-category/project-category.facade';
import { ProjectTypeFacade } from './../../../../../epims-references/src/lib/states/+project-type/project-type.facade';
import { LgaFacade } from './../../../../../epims-references/src/lib/states/+lga/lga.facade';
import { StateFacade } from './../../../../../epims-references/src/lib/states/+state/state.facade';
import { CountryFacade } from './../../../../../epims-references/src/lib/states/+country/country.facade';
import { Component, OnInit } from '@angular/core';
import {
  ProjectDto,
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  CommunityDto,
  OilBlockDto,
  OilFieldDto,
  CurrencyDto,
  GMOUDto,
  DocumentSubCategoryDto,
  DocumentCategoryDto,
  ProjectActivityDto,
} from '@cradua/data';
import { Observable } from 'rxjs';
import { ProjectManagementFacade } from '../../states/+project-management/project-management.facade';
import { GmouFacade } from '../../states/+gmou/gmou.facade';
import { ProjectActivityFacade } from '../../states/+project-activity/project-activity.facade';

@Component({
  selector: 'mrsoftapps-project-management-container',
  templateUrl: './project-management-container.component.html',
  styleUrls: ['./project-management-container.component.scss'],
})
export class ProjectManagementContainerComponent implements OnInit {
  isLoadingProjectManagement$: Observable<any>;
  isLoadingCountry$: Observable<any>;
  isLoadingState$: Observable<any>;
  isLoadingLga$: Observable<any>;
  isLoadingProjectType$: Observable<any>;
  isLoadingProjectCategory$: Observable<any>;
  isLoadingCluster$: Observable<any>;
  isLoadingClusterCommunity$: Observable<any>;
  isLoadingCommunity$: Observable<any>;
  isLoadingOilBlock$: Observable<any>;
  isLoadingOilField$: Observable<any>;
  isLoadingDocumentCategory$: Observable<any>;
  isLoadingDocumentSubCategory$: Observable<any>;
  isLoadingCurrency$: Observable<any>;
  isLoadingGmou$: Observable<any>;
  isLoadingProjectActivity$: Observable<any>;

  projectManagement$: Observable<ProjectDto[]>;
  searchProjectManagement$: Observable<ProjectDto[]>;
  country$: Observable<CountryDto[]>;
  state$: Observable<StateDto[]>;
  lga$: Observable<LgaDto[]>;
  projectType$: Observable<ProjectTypeDto[]>;
  projectCategory$: Observable<ProjectCategoryDto[]>;
  cluster$: Observable<ClusterDto[]>;
  clusterCommunity$: Observable<ClusterCommunityDto[]>;
  community$: Observable<CommunityDto[]>;
  oilBlock$: Observable<OilBlockDto[]>;
  oilField$: Observable<OilFieldDto[]>;
  documentCategory$: Observable<DocumentCategoryDto[]>;
  documentSubCategory$: Observable<DocumentSubCategoryDto[]>;
  projectActivity$: Observable<ProjectActivityDto[]>;
  currency$: Observable<CurrencyDto[]>;
  gmou$: Observable<GMOUDto[]>;
  projectData: ProjectDto;

  task = 'list';
  selectedGMOUId: any;
  constructor(
    private projectManagementFacade: ProjectManagementFacade,
    private countryFacade: CountryFacade,
    private stateFacade: StateFacade,
    private lgaFacade: LgaFacade,
    private projectTypeFacade: ProjectTypeFacade,
    private projectCategoryFacade: ProjectCategoryFacade,
    private clusterFacade: ClusterFacade,
    private clusterCommunityFacade: ClusterCommunityFacade,
    private communityFacade: CommunityFacade,
    private oilBlockFacade: OilBlockFacade,
    private oilFieldFacade: OilFieldFacade,
    private documentCategoryFacade: DocumentCategoryFacade,
    private documentSubCategoryFacade: DocumentSubCategoryFacade,
    private gmouFacade: GmouFacade,
    private currencyFacade: CurrencyFacade,
    private projectActivityFacade: ProjectActivityFacade
  ) {}

  ngOnInit() {
    this.isLoadingProjectManagement$ = this.projectManagementFacade.isLoadingProjectManagement;
    this.isLoadingCountry$ = this.countryFacade.isLoadingCountry;
    this.isLoadingState$ = this.stateFacade.isLoadingState;
    this.isLoadingLga$ = this.lgaFacade.isLoadingLga;
    this.isLoadingCommunity$ = this.communityFacade.isLoadingCommunity;
    this.isLoadingOilBlock$ = this.oilBlockFacade.isLoadingOilBlock;
    this.isLoadingClusterCommunity$ = this.clusterCommunityFacade.isLoadingClusterCommunity;
    this.isLoadingCluster$ = this.clusterFacade.isLoadingCluster;
    this.isLoadingProjectType$ = this.projectTypeFacade.isLoadingProjectType;
    this.isLoadingProjectCategory$ = this.projectCategoryFacade.isLoadingProjectCategory;
    this.isLoadingOilField$ = this.oilFieldFacade.isLoadingOilField;
    this.isLoadingDocumentSubCategory$ = this.documentSubCategoryFacade.isLoadingDocumentSubCategory;
    this.isLoadingDocumentCategory$ = this.documentCategoryFacade.isLoadingDocumentCategory;
    this.isLoadingCurrency$ = this.currencyFacade.isLoadingCurrency;
    this.isLoadingGmou$ = this.gmouFacade.isLoadingGmou;
    this.isLoadingProjectActivity$ = this.projectActivityFacade.isLoadingProjectActivity;

    this.country$ = this.countryFacade.loadCountry;
    this.state$ = this.stateFacade.loadState;
    this.lga$ = this.lgaFacade.loadLga;
    this.community$ = this.communityFacade.loadCommunity;
    this.oilBlock$ = this.oilBlockFacade.loadOilBlock;
    this.clusterCommunity$ = this.clusterCommunityFacade.loadClusterCommunity;
    this.projectType$ = this.projectTypeFacade.loadProjectType;
    this.cluster$ = this.clusterFacade.loadCluster;
    this.projectCategory$ = this.projectCategoryFacade.loadProjectCategory;
    this.oilField$ = this.oilFieldFacade.loadOilField;
    this.documentSubCategory$ = this.documentSubCategoryFacade.loadDocumentSubCategory;
    this.documentCategory$ = this.documentCategoryFacade.loadDocumentCategory;
    this.gmou$ = this.gmouFacade.loadGmou;
    this.currency$ = this.currencyFacade.loadCurrency;
    this.projectActivity$ = this.projectActivityFacade.loadProjectActivity;
    this.projectManagement$ = this.projectManagementFacade.loadProjectManagement;
  }

  onViewProject(value) {
    this.projectData = value;
    this.task = 'activity';
  }

  oncreateProjectEmit(value) {
    this.selectedGMOUId = value;
    this.task = 'create';
    this.projectData = null;
  }

  onTriggerEmit(value) {
    event.preventDefault();
    if (value.id) {
      this.projectManagementFacade.updateProjectManagement(value);
      this.task = 'list';
    } else {
      this.projectManagementFacade.addProjectManagement(value);
      this.task = 'list';
    }
  }

  onEmitActivity(value) {
    event.preventDefault();
    const pullData = value.ProjectActivities;

    let allUpdates = [];
    let addAllProjectActivity = [];

    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== undefined) {
        allUpdates.push(pullData[i]);
      } else {
        addAllProjectActivity.push(pullData[i]);
      }
    }

    if (addAllProjectActivity.length !== 0) {
      this.projectActivityFacade.addProjectActivity(addAllProjectActivity);
    }
  }

  onDeleteActivityEvent(id) {
    this.projectActivityFacade.removeProjectActivity(id);
  }

  onEditEvent(value) {
    this.projectData = value;
    this.task = 'create';
  }

  deleteProjectEvent(id) {
    this.projectManagementFacade.removeProjectMain(id);
  }

  taskEvent(value) {
    this.task = value;
  }

  onDeleteEVent(value) {
    this.projectManagementFacade.removeProjectManagement(value);
  }
}
